// extracted by mini-css-extract-plugin
module.exports = {"photo":"styles_photo__1-meD","header":"styles_header__mh9kc","label":"styles_label__1wDgX","description":"styles_description__7UW_U","pointer":"styles_pointer__2DHRN"};